const storage = {
  init: () => {
    localStorage.setItem('pio', JSON.stringify({}));
  },

  get: (key = null) => {
    let data = localStorage.getItem('pio');
    if (!data) return storage.init();
    data = JSON.parse(data);

    // eslint-disable-next-line no-restricted-globals
    if (data?.[key] && !isNaN(data[key])) return Number(data[key]);

    if (key?.includes('.')) {
      const keys = key.split('.');
      return keys.reduce((result, item) => result?.[item], data);
    }

    return key ? data[key] : data;
  },

  set: obj => {
    if (typeof obj !== 'object') return;
    let data = localStorage.getItem('pio') || '{}';
    data = JSON.parse(data);
    localStorage.setItem('pio', JSON.stringify({ ...data, ...obj }));
  },

  remove: key => {
    let data = localStorage.getItem('pio') || '{}';
    data = JSON.parse(data);
    delete data[key];
    localStorage.setItem('pio', JSON.stringify({ ...data }));
  },
};

export default storage;
